import React, { useEffect, useState } from 'react';
import Blog from '../../components/templates/Blog';
import BlogPosts from '../../data/blog/posts';

function BlogDetailPage({ post, recentPosts }) {
  const [showReturn, setShowReturn] = useState(false);

  // useEffect(() => {
  //   if (typeof window === 'undefined') return;
  //   setShowReturn(window.location.search === '?ori=SF&int_source=pagina-blog');
  // }, []);

  return <Blog post={post} recentPosts={recentPosts} showReturn={showReturn} />;
}

export const config = {
  amp: false,
};

export async function getStaticProps({ params: { slug } }) {
  const post = BlogPosts.find((post) => post.slug === slug);
  const recentPosts = BlogPosts.sort((a, b) => {
    return new Date(b.publishDate) - new Date(a.publishDate);
  })
    .filter((p) => p.slug !== slug)
    .slice(0, 10);

  return {
    props: { post, recentPosts, importPrefix: '../' },
  };
}

export async function getStaticPaths() {
  const paths = BlogPosts.map((post) => ({ params: { slug: post.slug } }));
  return {
    paths,
    fallback: false,
  };
}

export default BlogDetailPage;
